import { render, staticRenderFns } from "./InvoiceIndex.vue?vue&type=template&id=4a8c225c&scoped=true"
import script from "./InvoiceIndex.vue?vue&type=script&lang=js"
export * from "./InvoiceIndex.vue?vue&type=script&lang=js"
import style0 from "./InvoiceIndex.vue?vue&type=style&index=0&id=4a8c225c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8c225c",
  null
  
)

export default component.exports